module.exports = __webpack_public_path__ + "img/science.d7168e83.svg";